import { useSelector } from 'react-redux';
import { getUser } from 'redux/slices/authSlice';
import ICalendarIntegrationV4 from './ICalendarIntegrationV4';

const ICalendarSettingsV4 = (props) => {
    const {
        organizationId,
        isMigrating
    } = props;
    const user = useSelector(getUser);

    if (isMigrating) return null;

    return (
        <>
            {/* Configuración básica de V4 */}
            {user?.role === 'root' && (
                <ICalendarIntegrationV4 organizationId={organizationId} />
            )}
        </>
    );
};

export default ICalendarSettingsV4;